import React, { useState, useEffect } from "react";
import { Layout } from "antd";
import Sidebar from "../common/Sidebar";
import SidebarDrawer from "../common/SidebarDrawer";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Outlet } from "react-router-dom";
import { validate } from "../store/authSlice";

const { Sider, Content } = Layout;

export default function MainLayout() {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const init = async () => {
      const token = localStorage.getItem("token");

      if (!token) {
        setLoading(false);
        return;
      }

      if (user) {
        setLoading(false);
        return;
      }

      try {
        await dispatch(validate());
      } catch (err) {
        localStorage.removeItem("token");
        dispatch({ type: "auth/logout" });
        navigate("/login");
      } finally {
        setLoading(false);
      }
    };

    init();
  }, [user]);

  return (
    <Layout style={{ minHeight: "100vh" }}>
      {!isMobile ? (
        <Sider
          width={220}
          style={{
            height: "100%",
            position: "sticky",
            top: 0,
          }}
        >
          <Sidebar />
        </Sider>
      ) : (
        <SidebarDrawer />
      )}

      <Layout style={{ display: "flex", flexDirection: "column" }}>
        <Content
          style={{
            flex: 1,
            minHeight: 0,
            padding: 24,
            background: "#f5f6fa",
            overflow: "auto",
          }}
        >
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
}
